<template>
  <transition name="slide-up">
    <div v-if="show" class="update-notification">
      <div class="notification-content">
        <div class="notification-icon">
          <i class="bi bi-arrow-clockwise"></i>
        </div>
        <div class="notification-text">
          <strong>¡Nueva versión disponible!</strong>
          <p>Hay una actualización de la aplicación lista para instalar.</p>
        </div>
        <div class="notification-actions">
          <button @click="updateApp" class="btn-update">
            <i class="bi bi-download"></i>
            Actualizar ahora
          </button>
          <button @click="dismissNotification" class="btn-dismiss">
            <i class="bi bi-x-lg"></i>
            Más tarde
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
defineProps({
  show: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update', 'dismiss']);

const updateApp = () => {
  emit('update');
};

const dismissNotification = () => {
  emit('dismiss');
};
</script>

<style scoped>
.update-notification {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: linear-gradient(135deg, #381cdc 0%, #5a3de8 100%);
  color: white;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
  padding: 16px;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 -4px 20px rgba(56, 28, 220, 0.3);
  }
  50% {
    box-shadow: 0 -4px 30px rgba(56, 28, 220, 0.6);
  }
}

.notification-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.notification-icon {
  font-size: 32px;
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.notification-text {
  flex: 1;
  min-width: 200px;
}

.notification-text strong {
  display: block;
  font-size: 16px;
  margin-bottom: 4px;
}

.notification-text p {
  margin: 0;
  font-size: 14px;
  opacity: 0.9;
}

.notification-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.btn-update,
.btn-dismiss {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-update {
  background-color: white;
  color: #381cdc;
}

.btn-update:hover {
  background-color: #f0f0f0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.btn-update:active {
  transform: translateY(0);
}

.btn-dismiss {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.btn-dismiss:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

/* Animación de entrada/salida */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.4s ease, opacity 0.4s ease;
}

.slide-up-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

/* Responsive para móviles */
@media (max-width: 768px) {
  .notification-content {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .notification-icon {
    font-size: 28px;
  }

  .notification-text {
    min-width: 100%;
  }

  .notification-actions {
    width: 100%;
    justify-content: center;
  }

  .btn-update,
  .btn-dismiss {
    flex: 1;
    justify-content: center;
    min-width: 120px;
  }
}
</style>
